import {Injectable, OnInit} from "@angular/core";
import {ComponentBase} from "../base/ComponentBase";
import {EventBus} from "../event/EventBus";
import {EnableExitButtonEvent, DisableExitButtonEvent} from "../event/ExitButtonEvents";
import {filter} from "rxjs/operators";

@Injectable()
export class ExitButtonEnabler extends ComponentBase {

    private enableButton: boolean = true;

    constructor(private eventBus: EventBus) {
        super("ExitButtonEnabler");
        this.setupListeners();
    }

    public isEnabled(): boolean {
        return this.enableButton;
    }

    private setupListeners() {

        let disableExitButtonEvent = this.eventBus.pipe(filter(event => event instanceof DisableExitButtonEvent)).subscribe(() => this.disableExitButton());
        this.subscriptions.push(disableExitButtonEvent);

        let enableExitButtonEvent = this.eventBus.pipe(filter(event => event instanceof EnableExitButtonEvent)).subscribe(() => this.enableExitButton());
        this.subscriptions.push(enableExitButtonEvent);
    }

    private disableExitButton(): void {
        this.enableButton = false;
    }

    private enableExitButton(): void {
        this.enableButton = true;
    }
}
